/**
 * Generated by orval v8.20.0 🍺
 * Do not edit manually.
 * Cloud Drive
 * In the documentation API requests will be sent from currently logged in user so you do not need to provide a bearer token manually. <br><br> When calling API from outside the documentation, you will need to provide an access token for all requests in authorization header: `Authorization: Bearer <Token>` <br> You can create a new access token in your account settings page.
 * OpenAPI spec version: 1.0.0
 */
import type {CheckLinkPasswordBody} from './schemas/check-link-password-body';

import type {CheckLinkPassword200} from './schemas/check-link-password200';

import type {CreateShareableLinkBody} from './schemas/create-shareable-link-body';

import type {CreateShareableLink200} from './schemas/create-shareable-link200';

import type {CrupdateShareableLinkRequest} from './schemas/crupdate-shareable-link-request';

import type {GetShareableLinkPageDataParams} from './schemas/get-shareable-link-page-data-params';

import type {GetShareableLinkPageData200} from './schemas/get-shareable-link-page-data200';

import type {RetrieveShareableLink200} from './schemas/retrieve-shareable-link200';

import type {UpdateShareableLink200} from './schemas/update-shareable-link200';

import {orvalApiFetch} from '../../../common/foundation/resources/client/http/query-client';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary Retrieve a shareable link
 */
export const retrieveShareableLink = (
  entryId: number,
  options?: SecondParameter<typeof orvalApiFetch<RetrieveShareableLink200>>,
) => {
  return orvalApiFetch<RetrieveShareableLink200>(
    {url: `/file-entries/${entryId}/shareable-link`, method: 'GET'},
    options,
  );
};
/**
 * @summary Create a new shareable link
 */
export const createShareableLink = (
  entryId: number,
  createShareableLinkBody?: CreateShareableLinkBody,
  options?: SecondParameter<typeof orvalApiFetch<CreateShareableLink200>>,
) => {
  return orvalApiFetch<CreateShareableLink200>(
    {
      url: `/file-entries/${entryId}/shareable-link`,
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      data: createShareableLinkBody,
    },
    options,
  );
};
/**
 * @summary Update a shareable link
 */
export const updateShareableLink = (
  entryId: number,
  crupdateShareableLinkRequest?: CrupdateShareableLinkRequest,
  options?: SecondParameter<typeof orvalApiFetch<UpdateShareableLink200>>,
) => {
  return orvalApiFetch<UpdateShareableLink200>(
    {
      url: `/file-entries/${entryId}/shareable-link`,
      method: 'PUT',
      headers: {'Content-Type': 'application/json'},
      data: crupdateShareableLinkRequest,
    },
    options,
  );
};
/**
 * @summary Delete a shareable link
 */
export const deleteShareableLink = (
  entryId: number,
  options?: SecondParameter<typeof orvalApiFetch<void>>,
) => {
  return orvalApiFetch<void>(
    {url: `/file-entries/${entryId}/shareable-link`, method: 'DELETE'},
    options,
  );
};
/**
 * @summary Import a shareable link into the user's own drive
 */
export const importIntoOwnDrive = (
  linkId: number,
  options?: SecondParameter<typeof orvalApiFetch<void>>,
) => {
  return orvalApiFetch<void>(
    {url: `/shareable-links/${linkId}/import`, method: 'POST'},
    options,
  );
};
/**
 * @summary Retrieve or render shareable link page
 */
export const getShareableLinkPageData = (
  hash: string,
  params?: GetShareableLinkPageDataParams,
  options?: SecondParameter<typeof orvalApiFetch<GetShareableLinkPageData200>>,
) => {
  return orvalApiFetch<GetShareableLinkPageData200>(
    {url: `/shareable-link-page/${hash}`, method: 'GET', params},
    options,
  );
};
/**
 * @summary Check if the password matches the link password
 */
export const checkLinkPassword = (
  hash: string,
  checkLinkPasswordBody: CheckLinkPasswordBody,
  options?: SecondParameter<typeof orvalApiFetch<CheckLinkPassword200>>,
) => {
  return orvalApiFetch<CheckLinkPassword200>(
    {
      url: `/shareable-link-page/${hash}/check-password`,
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      data: checkLinkPasswordBody,
    },
    options,
  );
};
export type RetrieveShareableLinkResult = NonNullable<
  Awaited<ReturnType<typeof retrieveShareableLink>>
>;
export type CreateShareableLinkResult = NonNullable<
  Awaited<ReturnType<typeof createShareableLink>>
>;
export type UpdateShareableLinkResult = NonNullable<
  Awaited<ReturnType<typeof updateShareableLink>>
>;
export type DeleteShareableLinkResult = NonNullable<
  Awaited<ReturnType<typeof deleteShareableLink>>
>;
export type ImportIntoOwnDriveResult = NonNullable<
  Awaited<ReturnType<typeof importIntoOwnDrive>>
>;
export type GetShareableLinkPageDataResult = NonNullable<
  Awaited<ReturnType<typeof getShareableLinkPageData>>
>;
export type CheckLinkPasswordResult = NonNullable<
  Awaited<ReturnType<typeof checkLinkPassword>>
>;
